import { useSelector, shallowEqual } from "react-redux";
import { ROLES } from "../../../lib/role-handler";
import { IState } from "../../../lib/store";


export default ({children}: {children: React.ReactNode}) => {
    const user = useSelector((state: IState) => state.auth.profile, shallowEqual)!;
    return <>{[ROLES.ADMIN, ROLES.OPERATOR].some((r) => user?.roles?.includes(r)) ? children : <></>}</>;
}